import { defineComponent } from "vue";
const createT = (component) => (key, fallback) => "$t" in component ? component.$t(key) : fallback;
export default defineComponent({
    methods: {
        getSourceIdsToNames(plannerItems) {
            const idsToPlannerItems = plannerItems.reduce((acc, plannerItem) => (Object.assign(Object.assign({}, acc), { [plannerItem._id]: plannerItem })), {});
            const getName = (plannerItem, { leaf }) => {
                const parent = plannerItem.parent_id && idsToPlannerItems[plannerItem.parent_id];
                const name = leaf ? `[${plannerItem.index}] ${plannerItem.name}` : plannerItem.name;
                if (!parent) {
                    return [name];
                }
                const parentName = getName(parent, { leaf: false });
                parentName.push(name);
                return parentName;
            };
            return plannerItems.reduce((acc, plannerItem) => (Object.assign(Object.assign({}, acc), { [plannerItem.source_id]: getName(plannerItem, { leaf: true }) })), {});
        },
        getLeafActualEvents(plannerItems, actualEvents) {
            const idsToSourceIds = plannerItems.reduce((acc, plannerItem) => {
                acc[plannerItem._id] = plannerItem.source_id;
                return acc;
            }, {});
            const leafSourceIds = new Set();
            plannerItems.forEach((plannerItem) => {
                const children = plannerItems.filter((item) => item.parent_id === plannerItem._id);
                if ((children.length > 0 &&
                    children.every((child) => !child.tracking_enabled) &&
                    plannerItem.tracking_enabled) ||
                    (children.length === 0 && plannerItem.tracking_enabled)) {
                    leafSourceIds.add(idsToSourceIds[plannerItem._id]);
                }
            });
            return actualEvents.filter((actualEvent) => actualEvent.source_id && leafSourceIds.has(actualEvent.source_id));
        },
        sortEventsByPlannerItems(plannerItems, events) {
            const sourceIdsToIndexex = plannerItems.reduce((acc, plannerItem, index) => {
                acc[plannerItem["source_id"]] = index;
                return acc;
            }, {});
            const eventsToSort = [...events];
            eventsToSort.sort((a, b) => sourceIdsToIndexex[a.source_id] - sourceIdsToIndexex[b.source_id]);
            return eventsToSort;
        },
        getStartEndDateValidationMessageForActualEvent(startDate, endDate, now, isMilestone) {
            const t = createT(this);
            if (!startDate) {
                return t("analytics.planner.event_validation.start_date_required", "Start date is required");
            }
            if (!endDate) {
                return t("analytics.planner.event_validation.end_date_required", "End date is required");
            }
            if (startDate > now) {
                return t("analytics.planner.event_validation.start_date_in_future", "Start date can't be in the future");
            }
            if (endDate > now) {
                return t("analytics.planner.event_validation.end_date_in_future", "Start date can't be in the future");
            }
            if (startDate > endDate) {
                return t("analytics.planner.event_validation.start_bigger_than_end", "Start date must be smaller than end date");
            }
            if (!isMilestone && startDate.getTime() === endDate.getTime()) {
                return t("analytics.planner.event_validation.start_bigger_than_end", "Start date must be smaller than end date");
            }
            return null;
        },
        getStartEndDateValidationMessageForPlannedEvent(startDate, endDate, isMilestone) {
            const t = createT(this);
            if (!startDate) {
                return t("analytics.planner.event_validation.start_date_required", "Start date is required");
            }
            if (!endDate) {
                return t("analytics.planner.event_validation.end_date_required", "End date is required");
            }
            if (startDate > endDate) {
                return t("analytics.planner.event_validation.start_bigger_than_end", "Start date must be smaller than end date");
            }
            if (!isMilestone && startDate.getTime() === endDate.getTime()) {
                return t("analytics.planner.event_validation.start_bigger_than_end", "Start date must be smaller than end date");
            }
            return null;
        },
    },
});
//# sourceMappingURL=PlanMixins.js.map